<header class="relative px-4 pb-4 pt-2">
  <h1 class="text-2xl font-semibold text-greyscale-900">Users</h1>
  <p class="text-sm text-greyscale-600">Manage users</p>
  <p-button
    label="Add User"
    icon="pi pi-plus"
    routerLink="create"
    class="absolute right-4 top-2"
  />
</header>

<main class="p-4">
  <p-table
    #dt
    [value]="filteredUsers"
    [paginator]="true"
    [rows]="20"
    [globalFilterFields]="[
      'firstName',
      'lastName',
      'emails[0].email',
      'company.name',
      'role',
    ]"
    styleClass="p-datatable-sm"
  >
    <ng-template #caption>
      <div class="flex flex-wrap items-end gap-4">
        <div class="min-w-[140px]">
          <span class="mb-1 block text-sm font-medium">Role</span>
          <p-select
            [options]="roleOptions"
            [(ngModel)]="roleFilter"
            optionLabel="label"
            optionValue="value"
            placeholder="All roles"
            [style]="{ width: '100%' }"
          />
        </div>
        <div>
          <p-button
            icon="pi pi-filter-slash"
            (onClick)="resetFilters()"
            [text]="true"
            [rounded]="true"
            pTooltip="Reset filters"
          />
        </div>
        <div class="ml-auto min-w-[200px]">
          <span class="mb-1 block text-sm font-medium">Search</span>
          <p-iconfield iconPosition="left">
            <p-inputicon>
              <i class="pi pi-search"></i>
            </p-inputicon>
            <input
              pInputText
              type="text"
              [(ngModel)]="globalFilter"
              (ngModelChange)="dt.filterGlobal(globalFilter, 'contains')"
              placeholder="Search users..."
              class="w-full"
            />
          </p-iconfield>
        </div>
      </div>
    </ng-template>

    <ng-template #header>
      <tr>
        <th>Name</th>
        <th>Company</th>
        <th>Role</th>
        <th>Email</th>
        <th>Last Connection</th>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td colspan="5" class="py-12 text-center">
          <div class="flex flex-col items-center gap-4">
            <i class="pi pi-users text-6xl text-greyscale-300"></i>
            <div class="flex flex-col gap-1">
              <h3 class="text-lg font-semibold text-greyscale-700">
                No users found
              </h3>
              <p class="text-sm text-greyscale-500">
                @if (globalFilter) {
                  Try adjusting your search criteria
                } @else {
                  Get started by adding your first user
                }
              </p>
            </div>
            @if (!globalFilter) {
              <p-button
                label="Add User"
                icon="pi pi-plus"
                routerLink="create"
                styleClass="mt-2"
              />
            }
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template #body let-user>
      <tr
        class="h-14 cursor-pointer hover:bg-gray-50"
        (click)="editUser(user.id)"
      >
        <td>
          <div class="flex flex-col">
            <span class="font-medium">{{ getUserName(user) }}</span>
          </div>
        </td>
        <td>{{ user.company?.name ?? "--" }}</td>
        <td>
          <span
            class="rounded-full bg-greyscale-100 px-2 py-1 text-xs font-medium text-greyscale-700"
          >
            {{ user.role ?? "--" }}
          </span>
        </td>
        <td class="text-sm text-greyscale-600">
          {{ user.emails?.[0]?.email ?? "--" }}
        </td>
        <td class="text-sm text-greyscale-600">
          {{ formatDate(user.lastLogin) }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</main>
